module.exports = __webpack_public_path__ + "static/article@2x-44d4226199335bb7a762f4dc8ca364f7.png";